import { Component, Input, ViewChild, Output, OnChanges } from '@angular/core';
import { MenuItem } from 'primeng/api/menuitem';
import { TieredMenu } from 'primeng/tieredmenu';
import { SlideMenu } from 'primeng/slidemenu';
import { EventEmitter } from '@angular/core';

export interface KuiOptionListItem {
    id?: number | string;
    name?: string;
    value?: any;
    selected?: boolean;
    children?: KuiOptionListItem[];
    parentRef?: KuiOptionListItem;
    selection?: 'single' | 'multiple';
}

@Component({
    moduleId: String(module.id),
    selector: 'kui-option-panel',
    templateUrl: './option-panel.component.html',
})
export class KuiOptionPanelComponent implements OnChanges {
    @Input() options: KuiOptionListItem[];
    items: MenuItem[];
    @Input() isMobile: boolean;

    @Output() selectionChanged = new EventEmitter<KuiOptionListItem>();

    @ViewChild('tmenu') tieredMenu: TieredMenu;
    @ViewChild('smenu') slideMenu: SlideMenu;

    ngOnChanges() {
        if (this.options) {
            this.items = this.options.map((item) => this.createMenuItem(item));
        }
    }

    toggle(event: Event) {
        if (this.tieredMenu) {
            this.tieredMenu.toggle(event);
        } else {
            this.slideMenu.toggle(event);
            this.slideMenu?.backwardViewChild?.nativeElement.children[0].classList.add('icon-chevron-left');
        }
    }

    createMenuItem(option: KuiOptionListItem): MenuItem {
        const optId = option.value ? option.value : option.id.toString();
        let menuItem: MenuItem = { id: optId, label: option.name };
    
        if (option.children) {
            menuItem.icon = 'icon-chevron-right';
            menuItem.items = option.children.map((child) => this.createMenuItem(child));
        } else {
            menuItem = { ...menuItem, command: (event) => this.onSelected(event.item) , icon: option.selected ? 'icon-check' : '', expanded: option.selected };
        }
        return menuItem;
    }

    onSelected(menuItem: MenuItem) {
        const optionListItem = { name: menuItem.label, value: menuItem.id };
        this.selectionChanged.emit(optionListItem);
    }
}
